import type React from 'react'
import { FormattedMessage } from 'react-intl'
import styled, { css } from 'styled-components'

import { RadioGroup, Typography } from '@components/ui'

import { DATE_WIDGET_VARIANTS } from '../constants'
import type { DateTypeOption } from '../types'

const StyledRadioGroup = styled(RadioGroup)<{
  $variant: ConstObjectValues<typeof DATE_WIDGET_VARIANTS>
}>`
  ${({ $variant, theme }) =>
    $variant === DATE_WIDGET_VARIANTS.list
      ? css`
          padding: 10px 0;
        `
      : css`
          padding: 20px;
          border-bottom: 1px solid ${theme.colors.common.paperStroke};
        `}

  & > label {
    white-space: nowrap;

    & > span:last-child {
      ${({ $variant, theme }) =>
        $variant === DATE_WIDGET_VARIANTS.list
          ? css`
              font-weight: 700;
            `
          : css`
              font-size: 14px;
              color: ${theme.colors.gray[100]};
            `}
    }
  }

  & label + label {
    margin-top: 10px;
  }
`

interface DateTypeSelectorProps {
  onChange: (values: Record<'dateField', string>) => void
  options: DateTypeOption[]
  value: string
  variant: ConstObjectValues<typeof DATE_WIDGET_VARIANTS>
}

export default function DateTypeSelector({ options, value, onChange, variant }: DateTypeSelectorProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ dateField: event.target.value })
  }

  return (
    <>
      {variant === DATE_WIDGET_VARIANTS.list && (
        <Typography size="700-xs" color="gray-80" uppercase tag="h4">
          <FormattedMessage id="dateTypeSelector.title" defaultMessage="Dátum típusa" />
        </Typography>
      )}
      <StyledRadioGroup $variant={variant} onChange={handleChange} value={value} options={options} withoutPadding />
    </>
  )
}
